import React, { useState } from "react";
import "./ProductCard.css";
import { useNavigate } from "react-router-dom";
import lazyCard from "../../../Assets/images/sector-card-lazy-load.gif";
const ProductCard = ({ product, onAddToCart, isLoading }) => {
  const navigate = useNavigate();
  const variant = product?.product_variants?.[0];
  const truncateText = (text, limit) => {
    if (!text) return "";
    return text.length > limit ? text.slice(0, limit) + "..." : text;
  };
  const [imgSrc, setImgSrc] = useState(product.image || lazyCard);
  const price = variant?.final_price || variant?.price || 0;
  const oldPrice = variant?.price || 0;
  const discount = variant?.discount || 0;

  return (
    <div className="p-card">
      {/* BADGES */}
      <div className="p-badges">
        <span className="best">Best Seller</span>
        {discount > 0 && <span className="save">Save {discount}%</span>}
      </div>

      <div
        className="p-img clickable"
        onClick={() => navigate(`/product/${product.slug}`)}
      >
        <img
          src={imgSrc}
          alt={product.name}
          loading="lazy"
          onError={() =>
            setImgSrc(
              "../../../Assets/images/SIDH-IMAGE-DEFAULT-SECTOR.jpg",
            )
          }
        />
      </div>
      <div className="p-body">
        {/* TITLE */}
        <h3
          className="p-title clickable"
          onClick={() => navigate(`/product/${product.slug}`)}
        >
          {truncateText(product.name, 22)}
        </h3>

        {/* VARIANT */}
        <div className="p-bottom">
          <div className="p-price">
            <div className="price-row">
              <div className="price-row-new">
                <span className="new">Rs. {price.toFixed(0)}</span>
                <span className="old">Rs. {oldPrice.toFixed(0)}</span>
              </div>
              <button className="p-btn" onClick={() => onAddToCart(product)}>
                {isLoading ? <span className="spinner"></span> : "ADD TO CART"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
